import request from '@/utils/request'

const basePath = '/api/aliyun/verify'

/**
 * 3元素校验身份信息
 * @param params 参数
 * @returns {AxiosPromise}
 */
export function id3MetaVerify(params) {
    return request({
        url: `${basePath}/id3`,
        method: 'POST',
        data: params
    })
}
